module.exports = __webpack_public_path__ + "static/img/wing_R880.3266a5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_R880.jpg
// module id = dsSt
// module chunks = 0